import { gql } from '@apollo/client';

export const REMOVE_BLOG_ARTICLE = gql`
  mutation ($id: String!) {
    removeBlogArticle(id: $id)
  }
`;
